import React, { createContext, useContext, useMemo } from 'react';
import { useHttpClientCore, useHttpClientIntegration } from '@/shared/infra/http/HttpClientContext';
import { ApiEverifyQueueAdminRepository } from '../repositories/ApiEverifyQueueAdminRepository';

export const EverifyQueueAdminDIContext = createContext<ApiEverifyQueueAdminRepository | undefined>(
  undefined
);

export const EverifyQueueAdminDIProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const integration = useHttpClientIntegration();
  const core = useHttpClientCore();
  const repository = useMemo(
    () => new ApiEverifyQueueAdminRepository(integration, core),
    [integration, core]
  );
  return (
    <EverifyQueueAdminDIContext.Provider value={repository}>
      {children}
    </EverifyQueueAdminDIContext.Provider>
  );
};

export const useEverifyQueueAdmin = (): ApiEverifyQueueAdminRepository => {
  const repository = useContext(EverifyQueueAdminDIContext);
  if (!repository)
    throw new Error('useEverifyQueueAdmin must be used inside EverifyQueueAdminDIProvider');
  return repository;
};
